import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getClasses, getLWClasses } from "../../../store/actions/class";
import { useRouter } from "next/router";
import { withUserAgent } from 'next-useragent';
import { generateUniqueId } from './../../../utils';
// import "../home/style.scss";
// import "./style.scss";
import { getLearnWorldUrl, getLWUserProfile } from "../../../api/learn_worlds";

function AppClasses(props) {
  const router = useRouter();
  const dispatch = useDispatch();
  const [isLogin, setIsLogin] = useState(false);
  const { classes, loadingClasses, savedSteps, user } = useSelector(
    (state) => ({
      classes: state.classReducer.classes,
      loadingClasses: state.classReducer.loadingClasses,
      savedSteps: state.applicationReducer.savedSteps,
      user: state.userAuth,
    }),
    shallowEqual
  );

  const [localClasses, setlLocalClasses] = useState([]);
  const [subHeader, setSubHeader] = useState({ fetchedData: false, hours: 0, courses: 0, certifications: 0 , subscription: true, myCourses: []});
  const [totalCourses, setTotalCourses] = useState(0);
  const [LMSURL, setLMSURL] = useState(null);
  const [filter, setFilter] = useState({
    all: false,
    onlyMe: true
    // free: false,
    // preminum: false,
  });

  useEffect(() => {
    // This method fetches information from local database...
    // dispatch(getClasses());
    // This method fetches information from LW API...
    dispatch(getLWClasses());
    if (user.authenticated && user.token) {
      setIsLogin(true);
      getLWUserProfile().then((res) => {
        // setLearnWorlds(res);
        if (Object.keys(res).length && res.success) {
          setSubHeader({
            fetchedData: true,
            hours: res?.user?.stats?.hours,
            courses: res?.user?.courses.length,
            certifications: res?.user?.certifications.length,
            subscription: res?.user?.subscription,
            myCourses: res.user.courses.map((cls) => {
              return cls.id
            })
          })
        }
      });
    }    
  }, []);

  useEffect(() => {
    // console.log("MyCourses Loaded");
    filterClasses("onlyMe");
  }, [subHeader.myCourses]);

  useEffect(() => {
    if (Object.keys(classes).length) {
      // console.log("Classes Loaded");
      setTotalCourses(Object.keys(classes).length);
      
      filterClasses((filter.onlyMe ? 'onlyMe' : 'all'));
      // filter.onlyMe ? 'onlyMe' : filter.free ? 'free' : filter.premium ? 'premium' : 'all'
      if (!isLogin) {
        setlLocalClasses(sortedClasses(classes));
      }
    }
  }, [classes]);

  useEffect(() => {
    if (LMSURL) {
      window.open(LMSURL);
    }
  }, [LMSURL]);

  const sortedClasses = ( data) => {
    let sortedClasses = [];
    for (const key in data) {
      if (data[key].status == "free") {
        sortedClasses.push(data[key]);
      }
    }
    for (const key in data) {
      if (data[key].status == "paid") {
        sortedClasses.push(data[key]);
      }
    }
    return sortedClasses;
  }

  const filterClasses = (category) => {
    if (category == "all") {
      setlLocalClasses(sortedClasses(classes));
      setFilter({ all: true, onlyMe: false });
    } else if (category == "onlyMe") {

      if (subHeader.myCourses.length) {
        let filterClasses = Object.keys(classes).map((cls) => {
          if (subHeader.myCourses?.includes(cls)) {
            return classes[cls];
          }
        }).filter(notUndefined => notUndefined !== undefined);
        // let filterClasses = Object.keys(classes).filter((cls) => subHeader.myCourses?.includes(cls) ? classes[cls] : "");
        setlLocalClasses(sortedClasses(filterClasses));
      } else {
        setlLocalClasses([]);
      }
      setFilter({ all: false, onlyMe: true });
    }
  };

  // const openIframe = (data) => {
  //   if (data) {
  //     // router.push('/home/course-library', `/course-library?title=${data.title.replace(/\ /g, '_')}`, { shallow: true });
  //     // router.push("/home/course-library", `/?id=${data}`, {
  //     //   shallow: true,
  //     // });
  //     window.localStorage.setItem("lms_url", data);
  //     router.push({
  //       pathname: '/course-library'
  //     })
  //   }
  // };

  const namingConvention = () => {
    return !!savedSteps && !!savedSteps.applicantInfo
      ? "My Application"
      : "Start Application";
  };

  // const [learnWorlds, setLearnWorlds] = useState(null);
  const handleCourseButton=(event, data)=>{
    event.preventDefault();
    if (isLogin) {
      if(event.target.className.includes('btn-in')) event.target.firstElementChild.classList.remove('hidden'); // previously Commented to resolve CORS issue on label click
      
      let redirectURL = `https://direct.bayanclaremont.org/`;
      redirectURL = (subHeader.fetchedData && subHeader.myCourses.includes(data.id)) ? `https://direct.bayanclaremont.org/course/${data.titleId}` : redirectURL;

      var importantStuff;
      if(props.ua.source !== 'BayanApp') importantStuff = window.open('https://direct.bayanclaremont.org', '_blank');
      getLearnWorldUrl(redirectURL).then((res) => {
         
        if (res.success) {
          if(props.ua.source !== 'BayanApp') importantStuff.location.href = res.url;
          else window.location.href = res.url;
          if(event.target.className.includes('btn-in')) event.target.firstElementChild.classList.add('hidden'); //previously Commented to resolve CORS issue on label click
        }
      });
    } else {
      window.open("https://direct.bayanclaremont.org/", "_blank");
    }
    
  }

  const handleSubscription=(event)=> {
    event.target.firstElementChild.classList.remove('hidden');
    const redirectURL = "https://direct.bayanclaremont.org/payment?product_id=bayan-all-access-pass&type=subscription";

    if(props.ua.source !== 'BayanApp') var importantStuff = window.open('https://direct.bayanclaremont.org', '_blank');
    getLearnWorldUrl(redirectURL).then((res) => {
      // setLearnWorlds(res);
      if (res.success) {
        if(props.ua.source !== 'BayanApp') importantStuff.location.href = res.url;
        else window.location.href = res.url;
        // setLMSURL(res.url);
        event.target.firstElementChild.classList.add('hidden');
        // window.localStorage.setItem("selected-course", data);
        // openIframe(res.url);
      }
    });
  }

  return (
    <>
      <div className="content network-block classes-block classes-page">
        {isLogin ? <div className="sub-header-with-courses">
          <ul>
            <li>
              <p>{subHeader.courses}</p>
              <p>Courses</p>
            </li>
            <li>
              <p>{subHeader.hours}</p>
              <p>Hours</p>
            </li>
            <li>
              <p>{subHeader.certifications}</p>
              <p>Completed</p>
            </li>
          </ul>
        </div> : <></>}

        <div className="wrapper">
          <div className="row">
            <div className="col col-md-3">
              <div className="card1 conection-list">
                <ul>
                  <li>
                    <h3 alt="Bayan On-Demand">Subscribe to Bayan On-Demand</h3>
                  </li>
                  <li>
                    <p>Our online courses are all available online for only $10 a month.</p>
                  </li>
                </ul>
                <a href="https://direct.bayanclaremont.org/" target="_blank" className="sub-btn btn btn-yellow">
                  Subscribe
                  {/* <img className="hidden" src={`/icons/loading.svg`} style={{ height: '25px', marginLeft: '10px' }} /> */}
                </a>
              </div> 
            </div>
            <div className="col col-md-8">
              {!subHeader.subscription  ?
                <div className="course-subscription-area">
                  {/* <span><img src="/icons/bayan-only.svg" alt="bayan-logo" width="150" /></span> */}
                  <div className="inner-area">
                    <p alt="Bayan On-Demand"><strong>You are not subscribed to Bayan On-Demand All Access Pass yet.</strong></p>
                    <p>You will only be able to view free courses (green button). Our online courses are all available for only $10 a month.</p>
                  </div>
                  <a onClick={(e) => handleSubscription(e)} className="sub-btn btn btn-yellow">Subscribe  <img className="hidden" src={`/icons/loading.svg`} style={{ height: '25px', marginLeft: '10px' }} /></a>
                </div>
                :
                <></>
              }
              
              <div className="my-conection my-classes" style={{ marginTop: '20px'}}>
                <h1 style={{ textAlign: 'center' }}>
                  {!isLogin ? <strong alt="Bayan On-Demand">Bayan On-Demand Classes</strong> : 
                    filter.all ? <strong>All Courses</strong> : subHeader.courses ? <strong>My Courses</strong> : <></>}
                </h1>
                <div className="conection-list mobile-only">
                  <ul>
                    <li onClick={() => filterClasses("all")} className={filter.all ? "active" : ""}>
                      <a>All Courses ({totalCourses})</a>
                    </li>
                    <li onClick={() => filterClasses("onlyMe")} className={filter.onlyMe ? "active" : ""}>
                      <a>My Courses ({subHeader.courses})</a>
                    </li>
                  </ul>
                </div>
                <div className="row">
                  {(subHeader.fetchedData || !isLogin) ? 
                    (
                      Object.keys(localClasses).map((cls) => {
                      return (
                        <div className="col-md-3a" key={generateUniqueId()} >
                          <div className="card card-vertical">
                            <div className="st-list">
                              <div className="st-in st-left">
                                <div className="class-image">
                                  <img
                                    src={`${localClasses[cls].courseImage.url}`}
                                    alt="network-icon"
                                  />
                                </div>
                                <div className="class-body">
                                  <label onClick={(e) => { handleCourseButton(e, localClasses[cls]) }}>{localClasses[cls].title}</label>
                                  <p>{localClasses[cls].keywords}</p>

                                  {localClasses[cls].status == "free" ? (
                                    <a
                                      onClick={(e) => { handleCourseButton(e, localClasses[cls]) }}
                                      className={`btn-in btn-green`}
                                    >
                                      {isLogin ? 'View Course' : (localClasses[cls].status == "free" ? "View Course" : "Subscribe")}
                                      <img className="hidden" src={`/icons/loading.svg`} style={{ height: '25px', marginLeft: '10px' }} />
                                    </a>
                                  ) : (
                                    <a
                                        onClick={(e) => { handleCourseButton(e, localClasses[cls]) }}
                                        className={`btn-in ${subHeader.subscription ? 'btn-green' : 'btn-yellow'}`}
                                      >
                                        {isLogin ? (subHeader.subscription ? "View Course" : "Subscribe") : "Subscribe"}
                                        <img className="hidden" src={`/icons/loading.svg`} style={{ height: '25px', marginLeft: '10px' }} />
                                    </a>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                    ) : 
                    <></>}
                </div>
                {(!subHeader.fetchedData && localClasses.length == 0)  ? (
                  <span
                    className="like-loader"
                    style={{ display: "flex", marginTop: "100px" }}
                  >
                    <img
                      src={`${process.env.IMAGES_BASE_URL}/static-content/general-loading.gif`}
                      style={{ height: "100px", margin: "0 auto" }}
                    />
                  </span>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withUserAgent(AppClasses);
